export const DEFAULT_FONT_SIZE = 14;
export const CELL_SPACES = 4;
export const CHECKBOX_WIDTH = 32;